import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import meTranslation from "./locales/me.json";
import enTranslation from "./locales/en.json";

import meProjects from "./locales/meprojects.json";
import enProjects from "./locales/enprojects.json";

const resources = {
  me: {
    translation: meTranslation,
    projectsTranslation: meProjects,
  },
  en: {
    translation: enTranslation,
    projectsTranslation: enProjects,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "me",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
